import { render, staticRenderFns } from "./Atividades.vue?vue&type=template&id=68fa45e3&scoped=true&"
import script from "./Atividades.vue?vue&type=script&lang=js&"
export * from "./Atividades.vue?vue&type=script&lang=js&"
import style0 from "./Atividades.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Atividades.vue?vue&type=style&index=1&id=68fa45e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa45e3",
  null
  
)

export default component.exports